import { render } from "./LangSelectMenu.vue?vue&type=template&id=395083ea&scoped=true"
import script from "./LangSelectMenu.vue?vue&type=script&lang=js"
export * from "./LangSelectMenu.vue?vue&type=script&lang=js"

import "./LangSelectMenu.vue?vue&type=style&index=0&id=395083ea&scoped=true&lang=css"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395083ea"]])

export default __exports__